import { Path } from "enums";
import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { NoPage } from "../components/commons";

const SeaoilPage = () => {
  return (
    <Switch>
      <Route exact path={Path.Seaoil} component={NoPage} />
      <Redirect to={Path.Seaoil} />
    </Switch>
  );
};

export default SeaoilPage;
